export default class ExtranetInvoicesIndex {

    constructor() {
        this.datatable = null;
        this.bindEvents();
        this.initDataTable();
        //window.application.setOnDataChangeListener(this);
    }

    initDataTable() {
        if (document.getElementById('invoices-datatable')) {
            this.datatable = $('#invoices-datatable').DataTable({
                responsive: true,
                order: [[1, 'desc']], // Order by date column descending
                columnDefs: [
                    { orderable: false, targets: [2] } // Disable ordering on actions column
                ],
                language: {
                    url: '/data-tables/locales/' + I18n.locale + '.json'
                }
            });
        }
    }

    bindEvents() {
    }

    onDataChanged(data) {
    }

    onDestroy() {
        if (this.datatable) {
            this.datatable.destroy();
        }
    }
}